/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiReleaseNote, UiRelease } from '../products.models';
import { PageEvent } from '@angular/material/paginator';
import { ProductsService } from 'src/app/services/products/products.service';
import { ConfigService } from '@windriver/authentication';

// Dialog box show show a product's release notes
@Component({
  selector: 'wsn-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss']
})
export class ReleaseNotesComponent implements OnInit {
  public releaseNotePage: UiReleaseNote[];
  public releaseNotePageNumber: number;
  public readonly releaseNotePageSize = 5;
  public notes: UiReleaseNote[];
  public loadingReleaseNotes = true;
  public minioUrl: string;
  public apiBackendBaseUrl: string;

  constructor(
    public dialogRef: MatDialogRef<ReleaseNotesComponent>,
    private productService: ProductsService,
    private configService: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data: UiRelease
  ) {}

  ngOnInit(): void {
    this.configService.configState.subscribe((config: any) => {
      if (config) {
        this.minioUrl = config.minioUrl;
        this.apiBackendBaseUrl = config.apiUrl;
      }
    });

    this.productService.getReleaseNotes(this.data.id).subscribe((data) => {
      this.notes = data;
      this.loadingReleaseNotes = false;

      this.notes = this.notes.map((rn) => {
        const releaseNote: UiReleaseNote = {
          feature: rn.feature,
          document: rn.document, // this.minioUrl + 'release-notes/' + btoa(rn.document.replace('release-notes/', '')),
          release_date: new Date(rn.release_date).toISOString().split('T')[0]
        };
        return releaseNote;
      });

      this.releaseNotePage = this.notes;

      if (this.notes) {
        this.releaseNotePage = this.notes.slice(0, this.releaseNotePageSize);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  handleReleaseNotePageEvent(event: PageEvent) {
    this.releaseNotePageNumber = event.pageIndex;
    const start = this.releaseNotePageNumber * this.releaseNotePageSize;
    const end = start + this.releaseNotePageSize;
    if (this.notes) {
      this.releaseNotePage = this.notes.slice(start, end);
    }
  }

  openReleaseNote(documentUrl: string): void {
    const encodedPath = encodeURIComponent(documentUrl);
    const apiUrl = `${this.apiBackendBaseUrl}/v1/tools/minio-render?path=${encodedPath}`;
    window.open(apiUrl, '_blank', 'noopener,noreferrer');
  }
}
